import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  desktopFreqBtnContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '10px',
    [theme.breakpoints.up('lg')]: {
      columnGap: '15px',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  mobilefreqBtnWrapper: {
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    width: 'max-content',
    border: `1px solid ${theme.palette.cinnamon.main}`,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

  btn: {
    padding: '12px 30px',
    border: `3px solid ${theme.palette.turmeric.main}`,
  },
});
